
import { createClient } from "@supabase/supabase-js";

const nodeEnv = typeof process !== "undefined" ? process.env : undefined;

const isDev =
  (import.meta as any).env?.MODE === "development" ||
  nodeEnv?.NODE_ENV === "development";

// Default values to prevent app from crashing
const supabaseUrl =
  (import.meta as any).env?.VITE_SUPABASE_URL || nodeEnv?.VITE_SUPABASE_URL || '';
const supabaseAnonKey =
  (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || nodeEnv?.VITE_SUPABASE_ANON_KEY || '';

// Optional log for local debugging
if (isDev && nodeEnv?.DEBUG_SUPABASE) {
  console.log("Supabase URL:", supabaseUrl);
  console.log(
    "Supabase Anon Key length:",
    supabaseAnonKey ? supabaseAnonKey.length : 0
  );
}

// Ensure required variables are present before creating the client
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase environment variables are missing. Please define VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage, // Use localStorage for session persistence
    persistSession: true,  // Persist the session
    autoRefreshToken: true, // Auto refresh token
    // PKCE: i link di recovery/conferma usano un `code` legato al device che
    // ha avviato la richiesta (code_verifier in storage). Impedisce la session
    // fixation: un token/codice forgiato da terzi non può stabilire una sessione.
    flowType: 'pkce',
    // detectSessionInUrl come funzione = predicato per il SOLO callback implicito.
    // Restituendo sempre false, i token grezzi nell'hash (#access_token) non
    // vengono mai consumati (blocca la session fixation via link forgiato),
    // mentre il `code` PKCE — gestito a parte e protetto dal code_verifier —
    // continua a essere scambiato automaticamente ovunque atterri il redirect.
    detectSessionInUrl: () => false,
    debug: false // Enable debug mode for auth
  }
});
